export default "__VITE_ASSET__kz1LbR1q__"